import csart from 'images/csart.png'
import cslogo from 'images/cslogo.png'
import ButtonMobileComponent from 'components/button-mobile'

function Index(props: any): JSX.Element {
  return (
    <div
      className='bg-white min-h-screen flex flex-col items-center justify-between p-5'
      style={{
        minHeight: 'calc(100vh - env(safe-area-inset-top) - env(safe-area-inset-bottom))',
      }}
    >
      <div className='flex flex-col items-center gap-8 flex-grow justify-center'>
        <div className='flex h-90 p-5 flex-col items-center gap-[var(--Main-System-10px,10px)] flex-shrink-0 self-stretch'>
          <img src={csart} alt='' />
        </div>
        <img src={cslogo} alt='Logo' className='w-[250px]' />
        <div className='flex flex-col items-center gap-4'>
          <div className='text-center'>
            <h5 className='text-[#474747] text-2xl font-bold mb-4'>Simplify Your School Commute!</h5>
            <p className='text-[#797979] text-base leading-6'>
              Your stress-free solution for school carpooling. Manage schedules, connect with parents.
            </p>
          </div>
        </div>
      </div>
      <div className='w-full flex flex-col items-center gap-4 mt-auto mb-0 md:mb-16'>
        <ButtonMobileComponent
          id='signin-button'
          text='Sign in'
          width='w-full md:w-[500px]'
          color='bg-custom-yellow'
          href='/signin'
        />
        <ButtonMobileComponent
          id='signup-button'
          text='Sign up'
          width='w-full md:w-[500px]'
          color='bg-custom-gray'
          href='/signup'
        />
      </div>
    </div>
  )
}

export default Index
